import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';

const athenaLink = new HttpLink({
  uri: '/athena/api/graphql',
  credentials: 'include',
});

const bffLink = new HttpLink({
  uri: '/api/internal/graphql',
  credentials: 'include',
});

export const productionClient = new ApolloClient({
  name: 'partnership-dashboard-fe',
  link: ApolloLink.split(
    (operation) => operation.getContext().clientName === 'athena', // Routes the query to the proper client
    athenaLink,
    bffLink,
  ),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          partnership: {
            merge: true,
          },
          odProtosListingsServicesListwithcertaintyproduct: {
            merge: true,
          },
        },
      },
    },
  }),
});
export const publicClient = new ApolloClient({
  link: new HttpLink({
    uri: '/api/graphql',
  }),
  cache: new InMemoryCache(),
});

export const testingClient = new ApolloClient({
  link: new HttpLink({
    uri: '/api/internal/graphql?mode=test',
    credentials: 'include',
  }),
  cache: new InMemoryCache(),
});
